import axios from "axios";

export default class MapService {
  async getProperties() {
    try {
      const response = await axios.get("/api/properties");
      return response.data;
    } catch (error) {
      console.error("Error fetching properties:", error);
      return [];
    }
  }

  // return mock data as if it was fetched from the server with a promise and axios
  async getMockProperties() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          {
            address: "215 Emily St, MountainView, CA",
            description: "Single family house with modern design",
            price: "3,889,000",
            type: "house",
            parking: true,
            bed: 5,
            bath: 4.5,
            size: 300,
            position: {
              lat: 37.50024109655184,
              lng: -122.28528451834352,
            },
          },
          {
            address: "108 Squirrel Ln &#128063;, Menlo Park, CA",
            description: "Townhouse with friendly neighbors",
            price: "3,050,000",
            type: "building",
            parking: true,
            bed: 4,
            bath: 3,
            size: 200,
            position: {
              lat: 37.44440882321596,
              lng: -122.2160620727,
            },
          },
          {
            address: "100 Chris St, Portola Valley, CA",
            description: "Spacious warehouse great for small business",
            price: "3,125,000",
            type: "warehouse",
            bed: 4,
            parking: true,
            bath: 4,
            size: 800,
            position: {
              lat: 37.39561833718522,
              lng: -122.21855116258479,
            },
          },
          {
            address: "98 Aleh Ave, Palo Alto, CA",
            description: "A lovely store on busy road",
            price: "4,225,000",
            type: "store",
            bed: 2,
            bath: 1,
            parking: true,
            size: 210,
            position: {
              lat: 37.423928529779644,
              lng: -122.1087629822001,
            },
          },
          {
            address: "2117 Su St, MountainView, CA",
            description: "Single family house near golf club",
            price: "1,700,000",
            type: "house",
            bed: 4,
            bath: 3,
            size: 200,
            parking: false,
            status: "for_sale",
            position: {
              lat: 37.40578635332598,
              lng: -122.15043378466069,
            },
          },
          {
            address: "197 Alicia Dr, Santa Clara, CA",
            description: "Multifloor large warehouse",
            price: "5,000,000",
            type: "warehouse",
            bed: 5,
            bath: 4,
            parking: false,
            status: "for_rent",
            size: 700,
            position: {
              lat: 37.36399747905774,
              lng: -122.10465384268522,
            },
          },
          {
            address: "700 Jose Ave, Sunnyvale, CA",
            description: "3 storey townhouse with 2 car garage",
            price: "3,850,000",
            type: "building",
            bed: 4,
            bath: 4,
            parking: true,
            size: 600,
            position: {
              lat: 37.38343706184458,
              lng: -122.02340436985183,
            },
          },
          {
            address: "868 Will Ct, Cupertino, CA",
            description: "Single family house in great school zone",
            price: "2,500,000",
            type: "house",
            bed: 3,
            bath: 2,
            parking: true,
            size: 100,
            position: {
              lat: 37.34576403052,
              lng: -122.04455090047453,
            },
          },
          {
            address: "655 Haylee St, Santa Clara, CA",
            description: "2 storey store with large storage room",
            price: "2,500,000",
            type: "store",
            bed: 3,
            bath: 2,
            parking: false,
            size: 450,
            position: {
              lat: 37.362863347890716,
              lng: -121.97802139023555,
            },
          },
          {
            address: "2019 Natasha Dr, San Jose, CA",
            description: "Single family house",
            price: "2,325,000",
            type: "house",
            bed: 4,
            bath: 3.5,
            size: 500,
            parking: false,
            position: {
              lat: 37.41391636421949,
              lng: -121.94592071575907,
            },
          },
        ]);
      }, 200);
    });
  }

  private getRootUrl(): string {
    return process.env.VUE_APP_API_BASE_URL || (process.env.NODE_ENV === "development" ? "http://localhost:8000" : "");
  }

  async getMapConfig(id: string) {
    try {
      const rootUrl = this.getRootUrl();
      const response = await axios.get(`${rootUrl}/api/mapConfig/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching map config:", error);
      throw error;
    }
  }

  async getMapData(mapConfigId: string) {
    try {
      const rootUrl = this.getRootUrl();
      console.log("getMapData", mapConfigId);
      const response = await axios.get(`${rootUrl}/api/mapData/${mapConfigId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching map data:", error);
      throw error;
    }
  }

  async submitFeedback(
    formId: string,
    recordId: string,
    targetField: string,
    feedback: string,
    recaptchaToken: string
  ) {
    try {
      const rootUrl = this.getRootUrl();
      const response = await axios.post(
        `${rootUrl}/api/marker/${formId}/${recordId}/feedback`,
        {
          feedback,
          targetField,
          recaptchaToken,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error submitting feedback:", error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  }
}
